import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verticals',
  templateUrl: './verticals.component.html',
  styleUrls: ['./verticals.component.scss']
})
export class VerticalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
